import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/app.css'

import CreateAxios from './axios'
new CreateAxios(store)
createApp(App).use(store).use(router).mount('#app')
